import { Modal } from 'react-bootstrap'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { useIntl } from 'react-intl'
import { Dispatch, SetStateAction } from 'react'

export const DeleteParticipantConfirmationModal = ({
    setDeleteShowModal,
    showDeleteModal,
    onDeleteSubmit,
    deleteLoading,
}: {
    setDeleteShowModal: Dispatch<SetStateAction<boolean>>
    showDeleteModal: boolean
    onDeleteSubmit: any
    deleteLoading: boolean
}) => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Modal
                show={showDeleteModal}
                onHide={() => setDeleteShowModal(false)}
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header closeButton>
                    <h2>{formatMessage({ id: 'Delete Participant' })}</h2>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {formatMessage({
                            id: `Are you sure you want to delete this participant?`,
                        })}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <BasicButton
                        height='44px'
                        border='none'
                        color='#F5F8FA'
                        textColor='#7E8299'
                        padding='12px 16px'
                        onClick={() => {
                            setDeleteShowModal(false)
                        }}
                        buttonText='Cancel'
                        minWidth={56}
                    />

                    <BasicButton
                        height='44px'
                        border='1px solid #4776E6'
                        color='#4776E6'
                        textColor='white'
                        padding='12px 24px'
                        onClick={() => {
                            onDeleteSubmit()
                        }}
                        buttonText='Confirm'
                        minWidth={56}
                        loading={deleteLoading}
                        disabled={deleteLoading}
                    />
                </Modal.Footer>
            </Modal>
        </>
    )
}

export const DeleteAgendaConfirmationModal = ({
    setDeleteShowModal,
    showDeleteModal,
    onDeleteSubmit,
    deleteLoading,
}: {
    setDeleteShowModal: Dispatch<SetStateAction<boolean>>
    showDeleteModal: boolean
    onDeleteSubmit: any
    deleteLoading: boolean
}) => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Modal
                show={showDeleteModal}
                onHide={() => setDeleteShowModal(false)}
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header closeButton>
                    <h2>{formatMessage({ id: 'Delete Agenda' })}</h2>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {formatMessage({
                            id: `Are you sure you want to delete this agenda?`,
                        })}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <BasicButton
                        height='44px'
                        border='none'
                        color='#F5F8FA'
                        textColor='#7E8299'
                        padding='12px 16px'
                        onClick={() => {
                            setDeleteShowModal(false)
                        }}
                        buttonText='Cancel'
                        minWidth={56}
                    />

                    <BasicButton
                        height='44px'
                        border='1px solid #4776E6'
                        color='#4776E6'
                        textColor='white'
                        padding='12px 24px'
                        onClick={() => {
                            onDeleteSubmit()
                        }}
                        buttonText='Confirm'
                        minWidth={56}
                        loading={deleteLoading}
                        disabled={deleteLoading}
                    />
                </Modal.Footer>
            </Modal>
        </>
    )
}

export const DeleteMeetingConfirmationModal = ({
    setDeleteShowModal,
    showDeleteModal,
    onDeleteSubmit,
    deleteLoading,
    isParticipant
}: {
    setDeleteShowModal: Dispatch<SetStateAction<boolean>>
    showDeleteModal: boolean
    onDeleteSubmit: any
    deleteLoading: boolean
    isParticipant?: boolean
}) => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Modal
                show={showDeleteModal}
                onHide={() => setDeleteShowModal(false)}
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header closeButton>
                    <h2>{formatMessage({ id: isParticipant ? 'Delete Participant' : 'Delete Meeting' })}</h2>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {formatMessage({
                            id: isParticipant ? `Are you sure you want to delete this participant?` : `Are you sure you want to delete this meeting?`,
                        })}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <BasicButton
                        height='44px'
                        border='none'
                        color='#F5F8FA'
                        textColor='#7E8299'
                        padding='12px 16px'
                        onClick={() => {
                            setDeleteShowModal(false)
                        }}
                        buttonText='Cancel'
                        minWidth={56}
                    />

                    <BasicButton
                        height='44px'
                        border='1px solid #4776E6'
                        color='#4776E6'
                        textColor='white'
                        padding='12px 24px'
                        onClick={() => {
                            onDeleteSubmit()
                        }}
                        buttonText='Confirm'
                        minWidth={56}
                        loading={deleteLoading}
                        disabled={deleteLoading}
                    />
                </Modal.Footer>
            </Modal>
        </>
    )
}

export const DeleteFileConfirmationModal = ({
    setDeleteShowModal,
    showDeleteModal,
    onDeleteSubmit,
    deleteLoading,
}: {
    setDeleteShowModal: Dispatch<SetStateAction<boolean>>
    showDeleteModal: boolean
    onDeleteSubmit: any
    deleteLoading: boolean
}) => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Modal
                show={showDeleteModal}
                onHide={() => setDeleteShowModal(false)}
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header closeButton>
                    <h2>{formatMessage({ id: 'Delete File' })}</h2>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {formatMessage({
                            id: `Are you sure you want to delete this file?`,
                        })}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <BasicButton
                        height='44px'
                        border='none'
                        color='#F5F8FA'
                        textColor='#7E8299'
                        padding='12px 16px'
                        onClick={() => {
                            setDeleteShowModal(false)
                        }}
                        buttonText='Cancel'
                        minWidth={56}
                    />

                    <BasicButton
                        height='44px'
                        border='1px solid #4776E6'
                        color='#4776E6'
                        textColor='white'
                        padding='12px 24px'
                        onClick={() => {
                            onDeleteSubmit()
                        }}
                        buttonText='Confirm'
                        minWidth={56}
                        loading={deleteLoading}
                        disabled={deleteLoading}
                    />
                </Modal.Footer>
            </Modal>
        </>
    )
}